import { render, staticRenderFns } from "./ImportList.vue?vue&type=template&id=67814848&"
import script from "./ImportList.vue?vue&type=script&lang=ts&"
export * from "./ImportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports